/**
 * @author NikolaV
 */
import { action, makeObservable, observable } from 'mobx';
import { Ajax } from '@shared/Ajax';
import { Notify } from '@shared/ui-native/Notify';
import { alphaNumSort } from '@shared/utils/utils-sort';


export class TasksStore implements ICrudStore<ITruckTask> {
    @observable items: ITruckTask[] = [];
    @observable isDoingAsyncWork: boolean = false;

    fetch = () => {
        this.isDoingAsyncWork = true;

        return Ajax({
            url: '/api/project_vehicle_column_tasks.json',
            data: {
                includeDeleted: true,
            },
        }).done(action('fetch tasks', (resp: any) => {
            resp.tasks = (resp.tasks || []).sort((t1, t2) => alphaNumSort(t1.name, t2.name));
            this.items = resp.tasks;
        })).always(() => this.isDoingAsyncWork = false);
    };

    create = (task: ITruckTask) => {
        if (task.name.trim().length === 0) return false;

        this.isDoingAsyncWork = true;
        return Ajax({
            url: 'api/add_project_vehicle_task.json',
            method: 'post',
            processData: false,
            data: {
                taskName: task.name,
            },
        }).done(({ task }) => {
            this.items.unshift({
                id: task.id,
                name: task.name,
            });
        }).fail(Notify.error)
          .always(() => this.isDoingAsyncWork = false);
    };

    update = (task: ITruckTask) => {
        const existingTask: ITruckTask = this.items.find(t => t.id === task.id);
        const newName = task.name;
        const oldName: string = existingTask.name;

        if (this.items.find(t => t.name.toLowerCase() === newName.toLowerCase())) {
            Notify.error('Task already exists');
            return false;
        }

        existingTask.name = newName;

        this.isDoingAsyncWork = true;
        return Ajax({
            url: 'api/edit_project_vehicle_task.json',
            method: 'post',
            processData: false,
            data: {
                taskId: task.id,
                taskName: newName,
            },
        }).done(Notify.success)
          .fail(() => {
              existingTask.name = oldName;
              Notify.error();
          }).always(() => this.isDoingAsyncWork = false);
    };

    remove = (itemId: number) => {
        if (!$.isNumeric(itemId)) return false;
        const fullItem = this.items.find(i => i.id === itemId);
        if (fullItem) {
            if (!confirm(kuura.getMessage('general.confirm_delete', fullItem.name))) return false;
        }

        return Ajax({
            url: 'api/delete_project_vehicle_task.json',
            method: 'post',
            processData: false,
            data: {
                taskId: itemId,
            },
        }).done(() => {
            this.items.splice(this.items.findIndex(t => t.id === itemId), 1);
            Notify.success();
        }).fail(Notify.error);
    };

    constructor() {
        makeObservable(this);
    }
}
